<script setup lang="ts">
import { ref } from 'vue'
import { useFirebaseStore } from '@/stores/firebase'
import TermsAndConditions from './TermsAndConditions.vue'

const firebaseStore = useFirebaseStore()

const props = defineProps<{
  termsAccepted: boolean
}>()

const acceptTermsCheckbox = ref(props.termsAccepted)
// Methods
const emit = defineEmits(['update:termsAccepted'])

const handleTermsAccepted = (acceptTerms: boolean) => {
  try {
    firebaseStore.updateUserAcceptTerms(acceptTerms)
  } catch (error) {
    console.error('Error updating terms acceptance:', error)
  } finally {
    if (acceptTerms) {
      emit('update:termsAccepted', acceptTerms)
    }
  }
}
</script>
<template>
  <div class="fixed inset-0 bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-50">
    <div class="bg-white rounded-lg w-4/5 max-w-2xl max-h-[90vh] flex flex-col shadow-lg">
      <div class="p-4 border-b border-gray-200">
        <h2 class="text-xl font-semibold">BWC Flywell</h2>
      </div>

      <div class="px-4 pt-2 text-sm text-gray-600">
        To access your dashboard for the first time, please review and accept the terms and
        conditions and privacy policy below.
      </div>
      <div class="p-4 overflow-auto flex-grow">
        <div class="flex flex-col gap-4">
          <!-- This div will contain the scrollable T&C text -->
          <div
            class="h-[300px] overflow-y-auto border border-gray-300 p-4 text-sm leading-relaxed whitespace-pre-line"
          >
            <TermsAndConditions />
          </div>

          <div class="flex items-center gap-2 mt-4">
            <input
              type="checkbox"
              id="accept-terms"
              v-model="acceptTermsCheckbox"
              class="h-4 w-4"
            />
            <label for="accept-terms" class="text-sm"
              >I have read and accept the Privacy Policy and Terms and Conditions</label
            >
          </div>
        </div>
      </div>

      <div class="p-4 border-t border-gray-200 flex justify-end">
        <button
          :disabled="!acceptTermsCheckbox"
          @click="handleTermsAccepted(acceptTermsCheckbox)"
          class="cursor-pointer px-4 py-2 rounded-md bg-green-500 text-white disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          Accept & Continue
        </button>
      </div>
    </div>
  </div>
</template>
